module.exports = __webpack_public_path__ + "static/juice-poster-025247462845c476c32446a6aff0369a.png";